import { Toast } from '@base-ui/react/toast'

export const toastManager = Toast.createToastManager()
